import { Mark } from '@tiptap/core'

const TextColorFix = Mark.create({
  name: 'textcolorfix',

  addOptions () {
    return {
      color: [null]
    }
  },

  addAttributes () {
    return {
      color: {
        default: null,
        parseHTML: element => {
          return element.style.color || element.getAttribute('data-color') || element.getAttribute('color') || null
        },
        renderHTML: attrs => {
          if (!attrs.color) {
            return {}
          }

          return {
            style: `color:${attrs.color}`
          }
        }
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'spancolo',
        getAttrs: element => {
          const color = element.style.color || element.getAttribute('data-color') || element.getAttribute('color')

          if (!color) {
            return false
          }

          return null
        }
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['spancolo', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      textcolorfix: attrs => ({ commands }) => {
        const value = attrs && attrs.color ? attrs.color : null

        if (!value) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, { color: value })
      }
    }
  }
})

export default TextColorFix
